import { render, staticRenderFns } from "./FormTextareaField.vue?vue&type=template&id=f6d1d216&"
import script from "./FormTextareaField.vue?vue&type=script&lang=js&"
export * from "./FormTextareaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports